import React, { useState } from "react";
import { graphql } from "gatsby";
import { Modal } from "react-bootstrap";
import "./mapContentBlock.scss";
import AnchorID from "../../atoms/AnchorID";
import ExtractRichText from "../../molecules/ExtractRichText";

export const ParagraphMapContentBlock = ({ node }) => {
  const [show, setShow] = useState(false);
  const {
    field_section_id,
    field_component_title,
    field_component_subtitle,
    field_body_text,
    field_cta,
    relationships,
  } = node;

  const image =
    relationships?.field_card_image?.relationships?.field_media_image
      ?.publicUrl;

  return (
    <div className="map-content-wrapper">
      <AnchorID id={field_section_id} />
      <div className="container general-container">
        {Boolean(field_component_title) && (<h2 data-aos="underlined" className="map-title underlined">{field_component_title}</h2>)}
        {Boolean(field_component_subtitle) && (<h3 className="map-subtitle">{field_component_subtitle}</h3>)}
        {Boolean(field_body_text) && (<div className="map-desc"><ExtractRichText richText={field_body_text?.value} /></div>)}
        <div
          className="map-content"
          onClick={() => setShow(true)}
          data-aos="fade-up"
        >
          <img src={image} alt="image" />
        </div>
        {Boolean(field_cta?.title) && (
          <a
            target={field_cta?.options?.attributes?.target}
            href={field_cta?.url}
            className="btn btn-white download-report mt-3"
          >
            {field_cta?.title}
          </a>
        )}
      </div>

      <Modal
        backdropClassName="map-content-modal-backdrop"
        className="map-content-modal"
        scrollable
        size="xl"
        fullscreen="lg-down"
        centered
        show={show}
        onHide={() => setShow(false)}
      >
        <img
          title="Click to close popup!"
          onClick={() => setShow(false)}
          src={image}
          alt="modal image"
        />
      </Modal>
    </div>
  );
};

export const fragment = graphql`
  fragment ParagraphMapContentBlock on paragraph__map_content_block {
    field_section_id
    field_component_title
    field_component_subtitle
    field_body_text {
      value
    }
    field_cta {
      title
      uri
      url
      options {
        attributes {
          target
        }
      }
    }
    relationships {
      field_card_image {
        relationships {
          field_media_image {
            publicUrl
          }
        }
      }
    }
  }
`;
